import { useLanguage } from "units/dashboard/context/LanguageProvider";
import { useCountUp } from "./useCountUp";

const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹";
const AR_DIGITS = "٠١٢٣٤٥٦٧٨٩";

function formatValue(value, decimals, lang) {
  if (lang === "en") {
    return value.toLocaleString("en-US", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }
  const str = value.toFixed(decimals);
  const digits = lang === "ar" ? AR_DIGITS : FA_DIGITS;
  return str.replace(/\d/g, (d) => digits[+d]).replace(/\./g, "٫");
}

export default function AnimatedCounter({
  to,
  decimals = 0,
  suffix = "",
  suffixEn,
  suffixAr,
  className,
}) {
  const { lang } = useLanguage();
  const { ref, value } = useCountUp(to);

  const suffixLocal =
    lang === "en"
      ? suffixEn ?? suffix
      : lang === "ar"
      ? suffixAr ?? suffix
      : suffix;

  return (
    <span ref={ref} className={className}>
      {formatValue(value, decimals, lang)}
      {suffixLocal}
    </span>
  );
}